import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ResponseStructure } from '@iq-central-front-end/share';

@Component({
  selector: 'iq-central-front-end-add-course-module-four',
  templateUrl: './add-quiz.component.html',
  styleUrls: ['./add-quiz.component.scss'],
})
export class AddQuizComponent implements OnInit {
  lessonId: any;
  quizQuestioForm: FormGroup;
  quizForm: FormGroup;
  sub: Subscription = new Subscription();
  courseCode: any;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private course: CourseService,
    private _global: GlobalService
  ) {}

  ngOnInit(): void {
    this.lessonId = this.route.snapshot.paramMap.get('id');
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.initQuizForm();
    this.initQuizQuestionForm();
  }

  initQuizQuestionForm() {
    this.quizQuestioForm = this.fb.group({
      lessonId: [],
      questions: this.fb.array([this.newQuestion]),
    });
  }
  initQuizForm() {
    this.quizForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  get newQuestion() {
    return this.fb.group({
      title: ['', Validators.required],
      answers: this.fb.array([
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
        this.fb.group({
          title: ['', Validators.required],
          isAnswer: [false],
        }),
      ]),
    });
  }

  get getQuizQuestion(): FormArray {
    return this.quizQuestioForm.get('questions') as FormArray;
  }

  getQuizAnswers(index): FormArray {
    // return this.quizForm.get('answers') as FormArray;
    return this.getQuizQuestion[index].get('answers') as FormArray;
  }

  addQuestion() {
    // Get the form control that will be added
    const newQuestionControl = this.getQuizQuestion;
    const lastIndex = newQuestionControl.length - 1;

    // Get the answers from the last question that will be added
    const lastQuestion = newQuestionControl.at(lastIndex).value;
    const answers = lastQuestion.answers;

    // Check for correct answers in the last question
    const correctAnswers = answers.filter((el: any) => el.isAnswer);

    // Validate the current question being added
    if (correctAnswers.length === 1) {
      // Valid - actually add the question (this seems to be what your original code intended)
      this.getQuizQuestion.push(this.newQuestion);
    } else if (correctAnswers.length < 1) {
      Swal.fire({
        title: 'Error',
        icon: 'info',
        html: '<p>You need to select one of the options as the correct answer</p>',
      });
    } else {
      Swal.fire({
        title: 'Error',
        icon: 'info',
        html: '<p>Only one option can be selected as the right answer to a question</p>',
      });
    }
  }

  removeQuestion(i: number) {
    if (i > 0) this.getQuizQuestion.removeAt(i);
  }

  submit(path?) {
    // Validate all questions before submitting
    if (!this.validateAllQuestions()) {
      return;
    }

    this._global.showSpinner();
    this.quizQuestioForm.get('lessonId').setValue(this.lessonId);
    const payload = this.quizQuestioForm.value;
    payload.name = this.quizForm.get('name').value;
    payload.description = this.quizForm.get('description').value;
    payload.contentType = 'QUIZ';

    this.sub.add(
      this.course.createQuiz(this.quizQuestioForm.value).subscribe({
        next: (res: ResponseStructure) => {
          if (path) {
            this._global.globalSuccessHandler(res);
            this.router.navigate(['courses/add-lesson', this.courseCode]);
          } else {
            this._global.globalSuccessHandler(res);
            this.router.navigate(['courses/course-details', this.courseCode]);
          }
        },
      })
    );
  }

  private validateAllQuestions(): boolean {
    const questionsArray = this.getQuizQuestion;

    for (let i = 0; i < questionsArray.length; i++) {
      const question = questionsArray.at(i).value;
      const answers = question.answers;
      const correctAnswers = answers.filter((answer: any) => answer.isAnswer);

      if (correctAnswers.length < 1) {
        Swal.fire({
          title: 'Error',
          icon: 'info',
          html: `<p>Question ${i + 1} needs one correct answer selected</p>`,
        });
        return false;
      } else if (correctAnswers.length > 1) {
        Swal.fire({
          title: 'Error',
          icon: 'info',
          html: `<p>Question ${
            i + 1
          } has multiple correct answers. Only one is allowed.</p>`,
        });
        return false;
      }
    }

    return true;
  }

  transformString(j) {
    switch (j) {
      case 0:
        return 'A';
        break;
      case 1:
        return 'B';
        break;
      case 2:
        return 'C';
        break;
      case 3:
        return 'D';
        break;
      default:
        break;
    }
  }
  transformNumber(i) {
    return i;
  }

  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be saved and you will be taken to the course overview page',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save',
    }).then((result) => {
      if (result.value) {
        this.submit();
      }
    });
  }

  addContent(path) {
    this.submit(path);
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }
}
